<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.service_driver_request_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #072e68">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        
        <div class="row">

          <h2>
            {{ $t("PLACEHOLDERS.personalData") }}
          </h2>
          <base-image-upload-input
            col="12"
            identifier="service_image"
            :placeholder="$t('PLACEHOLDERS.personalImage')"
            :preSelectedImage="data.personalImage"
            disabled
          />
          <!-- Start:: Ar Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.identity')"
            v-model.trim="data.identity"
            disabled
          />
          <!-- End:: Ar Name Input -->
          <h2>
            {{ $t("PLACEHOLDERS.carData") }}
          </h2>
          <!-- Start:: En Name Input -->
          <base-image-upload-input
            col="12"
            identifier="service_image"
            :placeholder="$t('PLACEHOLDERS.licenseImg')"
            :preSelectedImage="data.licenseImg"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.carNum')"
            v-model.trim="data.carNum"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.licenseNum')"
            v-model.trim="data.licenseNum"
            disabled
          />

          <!-- End:: count_stores Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";

export default {
  name: "CreateArea",
  components: {
    UploadsPhotos,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        personalImage: null,
        name: null,
        phone: null,
        identity: null,
        licenseImg: null,
        carNum: null,
        licenseNum: null,
        desc: null,
        mainC: null,
        subC: null,
        state: null,
        city: null,
        lat: null,
        lng: null,
        district: null,
        storeLocation: null,
        street: null,
        twoer: true,
        vehicle_license_image_face: true,
        vehicle_license_image_back: true,
        work_hours: [],
      },
      additionalImages: [],
      imgUrls: [],
      markers: [],

      // End:: Data Collection To Send
    };
  },

  methods: {
    getDay(id) {
      if (id == 1) {
        return this.$t("PLACEHOLDERS.1");
      }
      if (id == 2) {
        return this.$t("PLACEHOLDERS.2");
      }
      if (id == 3) {
        return this.$t("PLACEHOLDERS.3");
      }
      if (id == 4) {
        return this.$t("PLACEHOLDERS.4");
      }
      if (id == 5) {
        return this.$t("PLACEHOLDERS.5");
      }
      if (id == 6) {
        return this.$t("PLACEHOLDERS.6");
      }
      if (id == 7) {
        return this.$t("PLACEHOLDERS.7");
      }
    },
    onFileSelect(files) {
      this.additionalImages = files;
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.imageId[index];
      try {
        await this.$axios({
          method: "GET",
          url: `delete-file/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        // Handle error as needed
        this.$message.error(error.response.data.message);
      }
    },
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `driver_join_requests/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.personalImage = res.data.data.JoinRequest.image;
        this.data.name = res.data.data.JoinRequest.name;
        this.data.phone = res.data.data.JoinRequest.mobile;
        this.data.identity = res.data.data.JoinRequest.identity_num;
        this.data.licenseImg = res.data.data.JoinRequest.license_file_path;
        this.data.carNum = res.data.data.JoinRequest.car_number;
        this.data.licenseNum = res.data.data.JoinRequest.car_license_number;
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
</style>
